import { Box, Grid, Typography, useTheme } from "@mui/material";
import ProductCard from "@/components/Products/ProductCard";
import Section from "@/components/Section";
import { useGetProductsQuery } from "@/redux-store/api/marketingApi";

const ProductsSection = () => {
  const theme = useTheme();
  const { data: products } = useGetProductsQuery({});

  return (
    <Section pt={{ xs: 7.5, md: 17.5 }} pb={{ xs: 10, md: 17.5 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: "761px",
            marginBottom: { xs: "40px", md: "80px" },
          }}
        >
          <Typography
            variant="h2"
            sx={{
              marginBottom: { xs: "16px", md: "24px" },
              textAlign: { xs: "start", md: "center" },
            }}
          >
            Proper Installation is Essential
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color={theme.palette.grey[600]}
            sx={{
              textAlign: { xs: "start", md: "center" },
            }}
          >
            Proper installation is key to ensuring your Trackmate devices operate at their highest capacity. 
            Download our step-by-step guides to ensure a smooth setup and optimal tracking performance.
          </Typography>
        </Box>
        {products && (
          <Grid container spacing={2}>
            {products.map((product) => (
              <Grid item xs={12} sm={6} md={4} key={product.id}>
                <ProductCard
                  withPrice={false}
                  withRating={false}
                  withDownload
                  withExplore={false}
                  product={product}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Section>
  );
};

export default ProductsSection;
